/*
 * Copyright (c) 2019. Legalbird eine Marke der R&S Internet Jewels GmbH
 */
import ApiClient from "./apiClient";
import _filter from "lodash/filter";

export const checkFileFormat = (filename, allowAudioAndVideo = false) => {
  const fileEnding = filename.slice(-5);

  const documentCheck = /(\.jpg)|(\.png)|(\.jpeg)|(\.pdf)/i.test(fileEnding);

  if (!allowAudioAndVideo) {
    return documentCheck;
  }

  return documentCheck || /(\.mpg)|(\.mpeg)|(\.opus)|(\.mp3)|(\.mp4)/i.test(fileEnding);
};

export const isAllowMultiplePagesFileType = (fileName) => {
  return /(\.jpg)|(\.png)|(\.jpeg)/i.test(fileName);
};

export const formatFilePath = (filePath, maxLength = 27) => {
  const outputString = filePath.replace("C:\\fakepath\\", "");
  if (outputString.length <= maxLength) {
    return outputString;
  }

  return outputString.slice(0, Math.round((maxLength - 5) / 2)) + " ... " + outputString.slice(-Math.round((maxLength - 5) / 2));
};

export const urltoFile = (url, filename, mimeType) => {
  return fetch(url)
    .then(function (res) {
      return res.arrayBuffer();
    })
    .then(function (buf) {
      return new File([buf], filename, { type: mimeType });
    });
};

export const postMediaObject = (file, fieldname) => {
  let formData = new FormData();
  formData.append("file", file);
  formData.append("fieldname", fieldname);
  let headers = new Headers();
  headers.set("Content-Type", "multipart/form-data");
  return ApiClient.post("/anonymous_media_objects", {
    headers: headers,
    body: formData,
  });
};

export const filterMediaObjectsByFieldname = (mediaObjectCollection, fieldName) => {
  return _filter(mediaObjectCollection, ["fieldname", fieldName]) || [];
};
